import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

import { latestRefulfillmentOrderSchema } from "./get-refulfillment-metrics";

export const getLatestRefulfillmentOrders = unaryRpc({
  name: "getLatestRefulfillmentOrders" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    locationId: z.string().optional(),
  }),
  output: z.object({ latestOrders: z.array(latestRefulfillmentOrderSchema) }),
});
